/* aurora — shared behaviour for aurora-* sections. Runs once per page. */
(function(){
  if (window.__auroraInit) return; window.__auroraInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Opens the cart after an add. Prefers the Upcart drawer; falls back to the cart page. */
  function openCart(cartUrl){
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch(e) {}
    try { if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; } } catch(e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    window.location.href = cartUrl || '/cart';
  }
  window.auroraOpenCart = openCart;

  function boot(){
    /* 1. Gentle reveal on scroll (skipped for reduced motion) */
    var els = document.querySelectorAll('.aur-reveal');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); }
    else {
      var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function(e){ io.observe(e); });
    }

    /* 2. Add-to-cart without leaving the page (forms marked .aur-atc) */
    document.querySelectorAll('form.aur-atc').forEach(function(f){
      f.addEventListener('submit', function(ev){
        if (!window.fetch) return;
        ev.preventDefault();
        var btn = f.querySelector('button'), label = btn ? btn.textContent : '';
        if (btn){ btn.disabled = true; btn.textContent = 'adding…'; }
        fetch(f.action.replace(/\/?$/, '') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
          .then(function(r){ if (!r.ok) throw 0; if (btn){ btn.disabled = false; btn.textContent = label; } openCart(f.dataset.cartUrl); })
          .catch(function(){ f.submit(); });
      });
    });

    /* 3. Mobile sticky bar that mirrors the hero buttons */
    var mq = window.matchMedia('(max-width:749px)');
    var hero = document.querySelector('.aur-hero'), ward = document.querySelector('[data-wardrobe]'), club = document.querySelector('.aur-club-sec');
    var secs = document.querySelectorAll('.aur-section'), last = secs[secs.length-1];
    if (hero) {
      var btns = hero.querySelectorAll('.aur-btns .aur-btn');
      var bar = document.createElement('div'); bar.className = 'aur aur-bar'; bar.setAttribute('aria-hidden','true');
      for (var b = 0; b < btns.length && b < 2; b++){ var a = document.createElement('a'); a.className = 'aur-btn' + (b ? ' ghost' : ''); a.href = btns[b].getAttribute('href'); a.textContent = btns[b].textContent.trim(); a.tabIndex = -1; bar.appendChild(a); }
      if (bar.children.length === 1) bar.style.gridTemplateColumns = '1fr';
      if (bar.children.length) document.body.appendChild(bar);
      var shown = false;
      var upd = function(){
        var on = false;
        if (mq.matches && bar.children.length){
          var vh = window.innerHeight; on = hero.getBoundingClientRect().bottom < 0;
          if (on && ward){ var w = ward.getBoundingClientRect(); if (w.top < vh && w.bottom > 0) on = false; }
          if (on && club && club.getBoundingClientRect().top < vh) on = false;
          if (on && last && last.getBoundingClientRect().bottom < vh) on = false;
        }
        if (on === shown) return; shown = on;
        bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', !on);
        bar.querySelectorAll('a').forEach(function(x){ x.tabIndex = on ? 0 : -1; });
      };
      var t = 0; window.addEventListener('scroll', function(){ if (!t){ t = requestAnimationFrame(function(){ t = 0; upd(); }); } }, { passive: true });
      window.addEventListener('resize', upd); upd();
    }

    /* 4. Scent wardrobe bundle builder (section is optional) */
    document.querySelectorAll('[data-wardrobe]').forEach(function(box){
      var data = []; try { data = JSON.parse(box.querySelector('[data-scents]').textContent); } catch(e) {}
      var launch = box.dataset.launch, cartAdd = box.dataset.cartAdd + '.js', cartUrl = box.dataset.cartUrl, cur = box.dataset.currency || 'GBP';
      var r3 = (parseFloat(box.dataset.rate3)||10)/100, r5 = (parseFloat(box.dataset.rate5)||20)/100;
      var st = { mode:'three', size:'v10', picked:[] };
      var tiles = box.querySelector('[data-tiles]'), add = box.querySelector('[data-add]');
      var fmt = function(c){ var v = c/100; try { return new Intl.NumberFormat('en-GB',{style:'currency',currency:cur,minimumFractionDigits:(v%1?2:0)}).format(v); } catch(e){ return '£'+(v%1?v.toFixed(2):v); } };
      var ok = function(s){ return s.avail && s[st.size] && s[st.size].ok; };
      data.forEach(function(s,i){
        var el = document.createElement('button'); el.type = 'button'; el.className = 'aur-tile'; el.dataset.i = i;
        el.innerHTML = '<span class="img">'+(s.img?'<img src="'+s.img+'" alt="" loading="lazy">':'')+'</span><span class="row"><span class="nm"></span><span class="box"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#FCF8EF" stroke-width="1.5" aria-hidden="true"><path d="M2.5 7.5l3 3 6-7"/></svg></span></span><span class="md" style="font-size:14px"></span><span class="aur-small tg"></span>';
        el.querySelector('.nm').textContent = s.name; el.querySelector('.md').textContent = s.mood || '';
        el.addEventListener('click', function(){ if (st.mode === 'all' || !ok(s)) return; var k = st.picked.indexOf(i); if (k > -1) st.picked.splice(k,1); else if (st.picked.length < 3) st.picked.push(i); render(); });
        tiles.appendChild(el);
      });
      box.querySelectorAll('[data-mode]').forEach(function(b){ b.addEventListener('click', function(){ st.mode = b.dataset.mode; render(); }); });
      box.querySelectorAll('[data-size]').forEach(function(b){ b.addEventListener('click', function(){ st.size = b.dataset.size; st.picked = st.picked.filter(function(i){ return ok(data[i]); }); render(); }); });
      function chosen(){ return st.mode === 'all' ? data.map(function(_,i){ return i; }) : st.picked; }
      function render(){
        box.querySelectorAll('[data-mode]').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.mode === st.mode); });
        box.querySelectorAll('[data-size]').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.size === st.size); });
        var all = st.mode === 'all', ch = chosen(), allOk = data.length >= 5 && data.every(ok);
        tiles.querySelectorAll('.aur-tile').forEach(function(t){
          var i = +t.dataset.i, s = data[i], sel = ch.indexOf(i) > -1, av = ok(s), bl = !all && !sel && st.picked.length >= 3;
          t.setAttribute('aria-pressed', sel && (av || all)); t.disabled = all || !av || bl;
          t.classList.toggle('dim', (!av && !all) || bl);
          t.querySelector('.tg').textContent = all ? (av ? 'included' : 'arrives ' + launch) : (!av ? 'arrives ' + launch : (sel ? 'picked' : 'tap to pick'));
        });
        var full = 0; ch.forEach(function(i){ var v = data[i][st.size]; if (v) full += v.price; });
        if (!all && ch.length < 3){ var avg = 0, n = 0; data.forEach(function(s){ if (s[st.size]){ avg += s[st.size].price; n++; } }); if (n) full = Math.round(avg/n)*3; }
        var price = Math.round(full*(1-(all?r5:r3)));
        box.querySelector('[data-label]').textContent = (all ? 'all 5 scents' : st.picked.length + ' of 3 picked') + ' · ' + (all ? '5' : '3') + ' × ' + (st.size === 'v10' ? '10ml' : '50ml');
        box.querySelector('[data-price]').textContent = (!all && ch.length < 3 ? 'from ' : '') + fmt(price);
        box.querySelector('[data-full]').textContent = fmt(full);
        box.querySelector('[data-save]').textContent = 'you save ' + fmt(full-price);
        var complete = all ? allOk : ch.length === 3;
        add.disabled = !complete;
        add.textContent = complete ? 'add bundle to bag — ' + fmt(price) : (all ? 'opens ' + launch : 'pick ' + (3-ch.length) + ' more');
        box.querySelector('[data-note]').textContent = (all && !allOk) ? 'the full wardrobe opens ' + launch : 'discount applied at checkout';
      }
      add.addEventListener('click', function(){
        var items = chosen().map(function(i){ var v = data[i][st.size]; return v ? { id: v.id, quantity: 1, properties: { '_bundle': 'scent wardrobe' } } : null; }).filter(Boolean);
        add.disabled = true; add.textContent = 'adding…';
        fetch(cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function(r){ if (!r.ok) throw 0; openCart(cartUrl); render(); })
          .catch(function(){ add.disabled = false; add.textContent = 'something went wrong — try again'; });
      });
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();